module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isShow) ? _c('div', {
    ref: "notice",
    staticClass: "notices"
  }, [_c(_vm.currentView, {
    tag: "component",
    attrs: {
      "transition": "fade",
      "transition-mode": "out-in",
      "params": _vm.params
    },
    on: {
      "isConfirm": _vm.isConfirm
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "noticeMask"
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c37191c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notice/notice.vue
// module id = 1184
// module chunks = 1